import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useSearchParams } from '@hooks';

import NavBar from '../NavBar';
import Svg from '../Svg';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Dropdown from '../Dropdown';
import Tooltip from '../Tooltip';

import HeaderPatientInfo from '../HeaderPatientInfo';
import { PatientInfoVisibility } from '../../types/PatientInfoVisibility';
import { decodeJWT } from '@/Decryption.js'
import { useLocation } from 'react-router-dom';
import { useAuth } from './../../../../../extensions/default/src/AuthContext';

function Header({
  children,
  menuOptions,
  menuOptionsLeft,
  isReturnEnabled,
  onClickReturnButton,
  isSticky,
  WhiteLabeling,
  showPatientInfo = PatientInfoVisibility.VISIBLE_COLLAPSED,
  servicesManager,
  Secondary,
  appConfig,
  commandsManager,
  ...props
}: withAppTypes): ReactNode {
  const { t } = useTranslation('Header');
  const IsSignalRExportingEnabled = window.config.IsSignalRExportingEnabled;
  const { isShareAuthenticated } = useAuth();


  const sharingConfigPermissions = window.config.isSharingEnabled;
  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };
  //-------------------------
  var tokenObject = {}

  const location = useLocation();
  const isShareUrl = location.pathname === "/share";

  if (menuOptionsLeft) {

    const { userAuthenticationService } = servicesManager?.services;
    const authorizationHeader = userAuthenticationService.getAuthorizationHeader()
      ? userAuthenticationService.getAuthorizationHeader().Authorization
      : '';
    console.log(`"${authorizationHeader.replace('Bearer ', '')}"`);
    if (authorizationHeader)
      tokenObject = decodeJWT(authorizationHeader.replace('Bearer ', ''))?.payload;
    console.log(tokenObject);
  }

  var isShare = false;
  if (menuOptionsLeft && location.pathname === "/share") {
    isShare = true;
    // console.log(tokenObject)
  }
  // if(!isShare){
  //   console.log(tokenObject.UserType);
  //   console.log(tokenObject.GroupName);
  //   if(tokenObject.GroupName =="Attorney" && tokenObject.UserType== "Attorney")

  // }

  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      <div className="relative h-[48px] items-center ">
        <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center">
          <div
            className={classNames(
              'mr-3 inline-flex items-center',
              isReturnEnabled && 'cursor-pointer'
            )}
            onClick={onClickReturn}
            data-cy="return-to-work-list"
          >
            {isReturnEnabled && (
              <Icon
                name="chevron-left"
                className="text-primary-active w-8"
              />
            )}            <div className="ml-1">
              {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Svg name="logo-ohif" />}
            </div>
          </div>
        </div>
        {/* <div className="absolute top-1/2 left-[250px]  h-8 -translate-y-1/2">{Secondary}</div> */}
        <div>
          {menuOptionsLeft && (
            <div className="absolute top-1/2 left-[248px]  flex h-8 w-20 -translate-y-1/2	">
              {/* <Dropdown
                id="options"
                showDropdownIcon={false}
                list={menuOptionsLeft}
                alignment="left"
                maxCharactersPerLine={100}
              >
                <IconButton
                  id={'options-tool-export'}
                  variant="text"
                  color="inherit"
                  size="initial"
                  className="text-primary-active hover:bg-primary-dark  h-[40px] w-[40px]"
                >
                  <Icon name="tool-export" />
                </IconButton>
              </Dropdown> */}
              {((tokenObject.allowBurning == 'True' && isShare && isShareAuthenticated)) &&
                <Tooltip
                  position="bottom"
                  className="group/fps cine-fps-range-tooltip"
                  tight={true}
                  content={'Download file to burn to a CD/DVD'}
                >
                  <IconButton
                    id={'options-tool-export'}
                    variant="text"
                    color="inherit"
                    size="initial"
                    onClick={() => {
                      commandsManager.runCommand('openExportStudy', { format: 'iso' });
                    }}
                    className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                  >
                    <Icon name="tool-export" />
                  </IconButton>
                </Tooltip>
              }

              {((tokenObject.allowBurning == 'True' && !isShare) || !tokenObject.hasOwnProperty('allowBurning')) &&
                <Tooltip
                  position="bottom"
                  className="group/fps cine-fps-range-tooltip"
                  tight={true}
                  content={'Download file to burn to a CD/DVD'}
                >
                  <IconButton
                    id={'options-tool-export'}
                    variant="text"
                    color="inherit"
                    size="initial"
                    onClick={() => {
                      commandsManager.runCommand('openExportStudy', { format: 'iso' });
                    }}
                    className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                  >
                    <Icon name="tool-export" />
                  </IconButton>
                </Tooltip>
              }

              {((tokenObject.allowDownloading == 'True' && !isShare) || !tokenObject.hasOwnProperty('allowDownloading')) &&
                <Tooltip
                  position="bottom"
                  className="group/fps cine-fps-range-tooltip ml-1"
                  tight={true}
                  content={'Download Study'}
                >
                  <IconButton
                    id={'options-tool-download'}
                    variant="text"
                    color="inherit"
                    size="initial"
                    onClick={() => {
                      commandsManager.runCommand('openDownloadStudy', { format: 'zip' });
                    }}
                    className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                  >
                    <Icon name="tool-download" />
                  </IconButton>
                </Tooltip>
              }
              {((tokenObject.allowDownloading == 'True' && isShare && isShareAuthenticated)) &&
                <Tooltip
                  position="bottom"
                  className="group/fps cine-fps-range-tooltip ml-1"
                  tight={true}
                  content={'Download Study'}
                >
                  <IconButton
                    id={'options-tool-download'}
                    variant="text"
                    color="inherit"
                    size="initial"
                    onClick={() => {
                      commandsManager.runCommand('openDownloadStudy', { format: 'zip' });
                    }}
                    className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                  >
                    <Icon name="tool-download" />
                  </IconButton>
                </Tooltip>
              }
              {/* {IsSignalRExportingEnabled == true && */}
              {sharingConfigPermissions && !isShareUrl
                // && tokenObject.GroupName !== "Attorney" && tokenObject.UserType !== "Attorney"
                &&
                < Tooltip
                  position="bottom"
                  className="group/fps cine-fps-range-tooltip"
                  tight={true}
                  content={'Share Studies'}
                >
                  <IconButton
                    id={'options-tool-share'}
                    variant="text"
                    color="inherit"
                    size="initial"
                    onClick={() => {
                      commandsManager.runCommand('openShareStudy');
                    }}
                    className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                  >
                    <Icon name="share-icon" />
                  </IconButton>
                </Tooltip>
              }
              {/* } */}
              {/* <Tooltip
                position="bottom"
                className="group/fps cine-fps-range-tooltip ml-1"
                tight={true}
                content={'Download Study'}
              >
                <IconButton
                  id={'options-tool-upload'}
                  variant="text"
                  color="inherit"
                  size="initial"
                  onClick={() => {
                    commandsManager.runCommand('openUploadStudy', { format: 'zip' });
                  }}
                  className="text-primary-active hover:bg-primary-dark  h-[35px] w-[35px]"
                >
                  <Icon name="tool-upload" />
                </IconButton>
              </Tooltip> */}
            </div>
          )}
        </div>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
          <div className="flex items-center justify-center space-x-2">{children}</div>
        </div>
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
          {showPatientInfo !== PatientInfoVisibility.DISABLED && !isShare && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          {showPatientInfo !== PatientInfoVisibility.DISABLED && isShare && isShareAuthenticated && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
          <div className="flex-shrink-0">
            <Dropdown
              id="options"
              showDropdownIcon={false}
              list={menuOptions}
              alignment="right"
            >
              <IconButton
                id={'options-settings-icon'}
                variant="text"
                color="inherit"
                size="initial"
                className="text-primary-active hover:bg-primary-dark h-full w-full"
              >
                <Icon name="icon-settings" />
              </IconButton>
            </Dropdown>
          </div>
        </div>
      </div>
    </NavBar >
  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
  showPatientInfo: PropTypes.string,
  servicesManager: PropTypes.object,
  commandsManager: PropTypes.object,
  menuOptionsLeft: PropTypes.array,
};

Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};

export default Header;
